import { Grid, Box, Typography } from '@mui/material'; // Button was defined but never used
import React, { useState } from 'react';

function Network() {
  const [iframeUrl, setIframeUrl] = useState("");
  // const [isFilterOn, setIsFilterOn] = useState(true); // isFilterOn was assigned a value but never used
  // const urls = [ // urls was assigned a value but never used
  //   "",
  //   "",
  // ];

  // const toggleUrl = () => { // toggleUrl was assigned a value but never used
  //   const nextUrlIndex = (urls.indexOf(iframeUrl) + 1) % urls.length;
  //   setIframeUrl(urls[nextUrlIndex]);
  //   setIsFilterOn(!isFilterOn);
  // };

  return (
    <Grid container sx={{ height: "100%", overflow: "hidden", position: "relative" }}>
      {/* iframe itself is responsive */}
      <iframe
        src={iframeUrl}
        style={{ width: "100%", height: "100%", border: "none" }}
        allowFullScreen
        title="iframe"
      ></iframe>

      {/* Overlay Box */}
      <Box sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.5)" // Optional overlay
      }}>
        {/* Use responsive font size for Typography */}
        <Typography
          component="h1" // Keep semantic element if desired
          sx={{
            // Define font size based on breakpoints
            fontSize: {
              xs: '2rem',  // Font size for extra-small screens
              sm: '3rem',  // Font size for small screens
              md: '3.75rem' // Font size for medium screens and up (like h2)
            },
            color: "#fff",
            textAlign: "center"
          }}
        >
          Coming Soon
        </Typography>
      </Box>

      {/* Commented out Button Box */}
      {/* ... */}
    </Grid>
  );

}

export default Network;